/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.10
 */

export type ReportsFindSimilarReportsSurveillanceType =
  (typeof ReportsFindSimilarReportsSurveillanceType)[keyof typeof ReportsFindSimilarReportsSurveillanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindSimilarReportsSurveillanceType = {
  active: 'active',
  passive: 'passive',
  other: 'other',
} as const;
